module.exports = __webpack_public_path__ + "static/media/riskHeartFailure.f77f1d84.mp3";